import { makeStyles } from "@material-ui/core";

const formStyles = makeStyles((theme) => ({
  formContent: {
    width: '1000px',
    margin: '0 auto',
    padding: '30px 0 0',

    '& input': {
      height: '32px'
    },

    '& .ant-form-item-label': {
      textAlign: 'left',
      fontWeight: 'bold',
    },

    '& .ant-form-item': {
      marginBottom: 30,
    }
  },
}));

export default formStyles;
